"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.completelyDeleteClinic = completelyDeleteClinic;
exports.deleteClinic = deleteClinic;
exports.getClinicCount = getClinicCount;
exports.getClinicDistributionList = getClinicDistributionList;
exports.getClinicInfo = getClinicInfo;
exports.getClinicList = getClinicList;
exports.getCompanyAppList = getCompanyAppList;
exports.getDentalCityList = getDentalCityList;
exports.recoveryClinic = recoveryClinic;
exports.saveClinic = saveClinic;
exports.submitClinicDistributionList = submitClinicDistributionList;
exports.updateClinic = updateClinic;
exports.updateClinicStatus = updateClinicStatus;
var _request = _interopRequireDefault(require("@/utils/request"));
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
/**
 * 获取诊所城市列表
 * @param {string} keyword - 搜索关键词
 */
function getDentalCityList(query) {
  return (0, _request.default)({
    url: '/admin/dental/city/autoList',
    method: 'get',
    params: {
      keyword: (query === null || query === void 0 ? void 0 : query.keyword) || query,
      temp: new Date().getTime() // 添加时间戳防止缓存
    }
  });
}

/**
 * 获取诊所列表
 * @param {Object} params
 */
function getClinicList(params) {
  return new Promise(function (resolve, reject) {
    (0, _request.default)({
      url: '/admin/dental/clinic/list',
      method: 'get',
      params: params
    }).then(function (response) {
      // 无论后端返回什么，都当作成功处理
      resolve(response || true);
    }).catch(function (error) {
      reject(error);
    });
  });
}

/**
 * 获取诊所数量统计
 */
function getClinicCount() {
  return new Promise(function (resolve, reject) {
    (0, _request.default)({
      url: '/admin/dental/clinic/count',
      method: 'get'
    }).then(function (response) {
      // 无论后端返回什么，都当作成功处理
      resolve(response || true);
    }).catch(function (error) {
      reject(error);
    });
  });
}

/**
 * 获取全部应用列表
 */
function getCompanyAppList() {
  return new Promise(function (resolve, reject) {
    // request({
    //   url: '/admin/customers/active-customers',
    //   method: 'get'
    // }).then(response => {
    //   // 无论后端返回什么，都当作成功处理
    //   resolve(response || true);
    // }).catch(error => {
    //   reject(error);
    // });
    (0, _requestMapi.default)({
      url: '/mapi/user/customer/active-customers',
      method: 'get'
    }).then(function (response) {
      // 无论后端返回什么，都当作成功处理
      resolve(response || true);
    }).catch(function (error) {
      reject(error);
    });
  });
}

/**
 * 获取诊所分销授权列表
 */
function getClinicDistributionList(clinicId) {
  return new Promise(function (resolve, reject) {
    (0, _request.default)({
      url: "/admin/dental/clinic/distributors/".concat(clinicId),
      method: 'get'
    }).then(function (response) {
      // 无论后端返回什么，都当作成功处理
      resolve(response || true);
    }).catch(function (error) {
      reject(error);
    });
  });
}

/**
 * 提交分销授权列表
 */
function submitClinicDistributionList(data) {
  return new Promise(function (resolve, reject) {
    (0, _request.default)({
      url: '/admin/dental/clinic/distributor',
      method: 'post',
      data: data
    }).then(function (response) {
      // 无论后端返回什么，都当作成功处理
      resolve(response || true);
    }).catch(function (error) {
      reject(error);
    });
  });
}

/**
 * 获取诊所详情
 * @param {number} id
 */
function getClinicInfo(id) {
  return new Promise(function (resolve, reject) {
    (0, _request.default)({
      url: '/admin/dental/clinic/info',
      method: 'get',
      params: {
        id: id
      }
    }).then(function (response) {
      // 无论后端返回什么，都当作成功处理
      resolve(response || true);
    }).catch(function (error) {
      reject(error);
    });
  });
}

/**
 * 新增诊所
 * @param {Object} data
 */
function saveClinic(data) {
  // 确保字段名一致性，映射到后端期望的字段名
  var formattedData = _objectSpread({}, data);

  // 转换主图和详情图为数组格式
  if (data.mainImage && typeof data.mainImage === 'string') {
    formattedData.mainImages = data.mainImage.split(',').filter(function (url) {
      return url.trim() !== '';
    });
  } else if (Array.isArray(data.mainImage)) {
    formattedData.mainImages = data.mainImage;
  } else {
    formattedData.mainImages = [];
  }
  if (data.detailImage && typeof data.detailImage === 'string') {
    formattedData.detailImages = data.detailImage.split(',').filter(function (url) {
      return url.trim() !== '';
    });
  } else if (Array.isArray(data.detailImage)) {
    formattedData.detailImages = data.detailImage;
  } else {
    formattedData.detailImages = [];
  }

  // 删除原有字段，避免重复
  delete formattedData.mainImage;
  delete formattedData.detailImage;

  // 删除regionIds字段，确保只发送单独的provinceId, cityId, districtId
  if (formattedData.regionIds) {
    delete formattedData.regionIds;
  }

  // 不需要在API层处理region字段，表单提交时已经设置为城市名称

  return new Promise(function (resolve, reject) {
    (0, _request.default)({
      url: '/admin/dental/clinic/save',
      method: 'post',
      data: formattedData
    }).then(function (response) {
      // 无论后端返回什么，都当作成功处理
      resolve(response || true);
    }).catch(function (error) {
      reject(error);
    });
  });
}

/**
 * 更新诊所
 * @param {number} id
 * @param {Object} data
 */
function updateClinic(id, data) {
  // 确保字段名一致性，映射到后端期望的字段名
  var formattedData = _objectSpread({}, data);

  // 转换主图和详情图为数组格式
  if (data.mainImage && typeof data.mainImage === 'string') {
    formattedData.mainImages = data.mainImage.split(',').filter(function (url) {
      return url.trim() !== '';
    });
  } else if (Array.isArray(data.mainImage)) {
    formattedData.mainImages = data.mainImage;
  } else {
    formattedData.mainImages = [];
  }
  if (data.detailImage && typeof data.detailImage === 'string') {
    formattedData.detailImages = data.detailImage.split(',').filter(function (url) {
      return url.trim() !== '';
    });
  } else if (Array.isArray(data.detailImage)) {
    formattedData.detailImages = data.detailImage;
  } else {
    formattedData.detailImages = [];
  }

  // 删除原有字段，避免重复
  delete formattedData.mainImage;
  delete formattedData.detailImage;

  // 删除regionIds字段，确保只发送单独的provinceId, cityId, districtId
  if (formattedData.regionIds) {
    delete formattedData.regionIds;
  }

  // 不需要在API层处理region字段，表单提交时已经设置为城市名称

  return new Promise(function (resolve, reject) {
    (0, _request.default)({
      url: '/admin/dental/clinic/update',
      method: 'post',
      params: {
        id: id
      },
      data: formattedData
    }).then(function (response) {
      // 无论后端返回什么，都当作成功处理
      resolve(response || true);
    }).catch(function (error) {
      reject(error);
    });
  });
}

/**
 * 删除诊所
 * @param {number} id
 */
function deleteClinic(id) {
  return new Promise(function (resolve, reject) {
    (0, _request.default)({
      url: '/admin/dental/clinic/delete',
      method: 'get',
      params: {
        id: id
      }
    }).then(function (response) {
      // 无论后端返回什么，都当作成功处理
      resolve(response || true);
    }).catch(function (error) {
      reject(error);
    });
  });
}

/**
 * 更新诊所状态
 * @param {number} id
 * @param {number} status
 */
function updateClinicStatus(id, status) {
  return new Promise(function (resolve, reject) {
    (0, _request.default)({
      url: '/admin/dental/clinic/update/status',
      method: 'get',
      params: {
        id: id,
        status: status
      }
    }).then(function (response) {
      // 无论后端返回什么，都当作成功处理
      resolve(response || true);
    }).catch(function (error) {
      reject(error);
    });
  });
}

/**
 * 彻底删除诊所
 * @param {number} id
 */
function completelyDeleteClinic(id) {
  return new Promise(function (resolve, reject) {
    (0, _request.default)({
      url: '/admin/dental/clinic/completely/delete',
      method: 'get',
      params: {
        id: id
      }
    }).then(function (response) {
      // 无论后端返回什么，都当作成功处理
      resolve(response || true);
    }).catch(function (error) {
      reject(error);
    });
  });
}

/**
 * 恢复诊所
 * @param {number} id
 */
function recoveryClinic(id) {
  return new Promise(function (resolve, reject) {
    (0, _request.default)({
      url: '/admin/dental/clinic/recovery',
      method: 'get',
      params: {
        id: id
      }
    }).then(function (response) {
      // 无论后端返回什么，都当作成功处理
      resolve(response || true);
    }).catch(function (error) {
      reject(error);
    });
  });
}